export default class ValidationResultManager {
  public static parseValidationResult(validationResult: any): {isValid: boolean, error: string} {
    return { isValid: validationResult.valid, error: validationResult.errors.join(', ') };
  }
}